module.exports = __webpack_public_path__ + "img/pdf.149a24fc.svg";